import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import NotFound from "../pages/NotFound";
import ListPage from "./pages/admin/ListPage";
import StudentsAddPage from "./pages/StudentsAddPage";
import StudentAccountPage from "./pages/StudentAccountPage";
import UserAccountPage from "./pages/admin/UserAccountPage";
import AdminsPage from "./pages/admin/roles/AdminsPage";
import AgentsPage from "./pages/admin/roles/AgentsPage";
import SchoolsPage from "./pages/admin/roles/SchoolsPage";
import StudentsPage from "./pages/admin/roles/StudentsPage";
import ServiceProvidersPage from "./pages/admin/roles/ServiceProvidersPage";
import { UserRole } from "./enums/UserRole";
import ParentsPage from "./pages/admin/roles/ParentsPage";
import TeachersPage from "./pages/admin/roles/TeachersPage";

export default function Users({ path }: { path: string }) {
  return (
    <>
      <Route path={path}>
        <Switch>
          <AuthRoute
            exact
            path={path}
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={ListPage}
          />
          <AuthRoute
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={UserAccountPage}
            path={`${path}/:id/edit`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={AdminsPage}
            path={`${path}/admin`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={AgentsPage}
            path={`${path}/agent`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={ParentsPage}
            path={`${path}/parent`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={TeachersPage}
            path={`${path}/teacher`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={SchoolsPage}
            path={`${path}/school`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Owner, UserRole.Admin, UserRole.Support]}
            component={ServiceProvidersPage}
            path={`${path}/service-provider`}
          />
          <AuthRoute
            exact
            roles={[
              UserRole.Owner,
              UserRole.Admin,
              UserRole.Support,
              UserRole.Agent,
              UserRole.Parent,
            ]}
            component={StudentsPage}
            path={`${path}/student`}
          />
          <AuthRoute
            exact
            roles={[UserRole.Agent, UserRole.Parent]}
            component={StudentsAddPage}
            path={`${path}/student/add`}
          />
          <AuthRoute
            roles={[UserRole.Agent, UserRole.Parent]}
            component={StudentAccountPage}
            path={`${path}/student/:id`}
          />
          <Route path={`${path}/*`} component={NotFound} />
        </Switch>
      </Route>
    </>
  );
}
